export type EntriesText = Record<string, string>;
